var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
import React from 'react';
import Neo4JIconBlackIcon from '../icons/generated/custom/Neo4JIconBlack';
import Neo4JIconColorIcon from '../icons/generated/custom/Neo4JIconColor';
import Neo4JIconWhiteIcon from '../icons/generated/custom/Neo4JIconWhite';
import Neo4JLogoBlackIcon from '../icons/generated/custom/Neo4JLogoBlack';
import Neo4JLogoColorIcon from '../icons/generated/custom/Neo4JLogoColor';
import Neo4JLogoWhiteIcon from '../icons/generated/custom/Neo4JLogoWhite';
import { useNeedleTheme } from '../theme';
const iconMap = {
    icon: {
        black: Neo4JIconBlackIcon,
        white: Neo4JIconWhiteIcon,
        color: Neo4JIconColorIcon,
    },
    full: {
        black: Neo4JLogoBlackIcon,
        white: Neo4JLogoWhiteIcon,
        color: Neo4JLogoColorIcon,
    },
};
/**
 * By default, Logo will be theme aware, unless `color` is explicitly provided.
 *
 * On light theme it will be colored and on dark theme it will be white.
 */
export const Logo = React.forwardRef(function Neo4jIcon(_a, ref) {
    var { color, type = 'full' } = _a, restProps = __rest(_a, ["color", "type"]);
    const theme = useNeedleTheme();
    // use themed logo if color is not explicitly provided
    const iconColor = color
        ? color
        : theme.theme === 'light'
            ? 'color'
            : 'white';
    const Icon = iconMap[type][iconColor];
    return _jsx(Icon, Object.assign({}, restProps, { ref: ref }));
});
//# sourceMappingURL=Logo.js.map